<template>
  <div class="layout-container">
    <!-- <header-page></header-page> -->
    <div class="main-container">
      <router-view></router-view>
    </div>
    <!-- <footer-page></footer-page> -->
    <div id="question-options-width"></div>
  </div>
</template>

<script>
import headerPage from '@/components/headerPage.vue'
import footerPage from '@/components/footerPage.vue'

export default {
  name: 'layout',
  components: {
    headerPage,
    footerPage,
  },
}
</script>
<style lang="scss" scoped>
.layout-container {
  height: 100%;
  width: 100%;
  .main-container {
    width: 100%;
    min-height: 714px;
    // background-color: #f2f2f2;
  }
}
#question-options-width {
  visibility: hidden;
  display: inline-block;
  font-size: 14px;
  position: absolute;
  left: -90000px;
  z-index: -9999999;
  padding: 0 20px;
}
</style>
